export const RecepPetLogo = ({ logoUrl, className = "h-11" }) => {
  if (logoUrl) {
    return <img src={logoUrl} alt="RecepPet" className={`${className} w-auto object-contain`} data-testid="header-logo-image" />;
  }
  return (
    <div className="flex items-center gap-2.5" data-testid="header-logo-svg">
      <svg viewBox="0 0 64 64" className={`${className} w-auto`} role="img" aria-label="RecepPet">
        <defs>
          <linearGradient id="rp-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00B074" />
            <stop offset="55%" stopColor="#00A86B" />
            <stop offset="100%" stopColor="#0B3C5D" />
          </linearGradient>
        </defs>
        <path
          d="M32 4 6 24v32a4 4 0 0 0 4 4h44a4 4 0 0 0 4-4V24L32 4Z"
          fill="none"
          stroke="url(#rp-grad)"
          strokeWidth="5"
          strokeLinejoin="round"
        />
        <circle cx="23" cy="26" r="3.4" fill="url(#rp-grad)" />
        <circle cx="32.5" cy="23.4" r="3.4" fill="url(#rp-grad)" />
        <circle cx="41.5" cy="26.5" r="3.4" fill="url(#rp-grad)" />
        <path
          d="M24 36h9.5c3.6 0 6 2.1 6 5.2 0 2.7-1.8 4.6-4.6 5.1L40 54h-5.4l-4.4-6.7H28V54h-4V36Zm4 3.6v4.4h5.1c1.6 0 2.6-.9 2.6-2.2 0-1.4-1-2.2-2.6-2.2H28Z"
          fill="url(#rp-grad)"
        />
      </svg>
      <span className="text-xl font-extrabold tracking-tight" style={{ color: "#002B49" }}>
        Recep<span style={{ color: "#00A86B" }}>Pet</span>
      </span>
    </div>
  );
};

export default RecepPetLogo;
